<template>
  <el-form
    ref="feesForWeightAndNoiseMasterForm"
    :model="model"
    :rules="rules"
    label-width="auto"
    label-position="left"
    class="fees-for-weight-and-noise-master-form"
  >
    <div class="el-form--inline">
      <!-- <BillingYm v-model="billingYm" :required="true" label="年度" :searchCond="searchMode" :mode="billingYmMode" :disabled="editMode" :autofocus="!editMode" />
       -->
      <ChargeYear v-model="chargeYear" label="料金年度"  prop="charge_year" yearType = "reference"  :required="true" :searchCond="true" :disabled="editMode" :autofocus="!editMode" :initialize="true" :tableType = tableType mode = "this" />
      <Select v-model="routeCode" label="線別" prop="route_code" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" codeId="ROUTE_CODE" :initialize="true" />
    </div>
    <div class="el-form--inline">
      <Select v-model="jetType" label="ジェット区分" prop="jet_type" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" codeId="JET_TYPE" :initialize="true" />
      <Select v-model="paidType" label="有償区分" prop="paid_type" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" codeId="PAID_TYPE" :initialize="true" />
    </div>
    <div class="el-form--inline">
      <Numeric v-model="minWeight" label="適用最小重量" prop="min_weight"
          :required="!searchMode" :searchCond="searchMode" :min="0" :max="9999" :step="1" :disabled="editMode" />
      <Numeric v-model="maxWeight" label="適用最大重量" prop="max_weight"
          :required="!searchMode" :searchCond="searchMode" :min="0" :max="9999" :step="1" :disabled="editMode" />
    </div>

    <template v-for="(tableComponent, form_index) in tableComponents">
      <el-divider :key="'el-divider_' + String(form_index)"/>
      <div :key="'div1_' + String(form_index)" class="el-form--inline">
        <div :key="'div2_' + String(form_index)">{{ tableComponent.label }}</div>
        <div :key="'div3_' + String(form_index)" class="parent_Box">
          <div :key="'div4_' + String(form_index)" class="child_Box">
              <!-- :v-model="getRefModelItem(tableComponent.model)" -->
            <el-checkbox
              v-if="editMode"
              :value="getModelItem(tableComponent.model)"
              @change="onChangeCheckBox($event, tableComponent.model, String(form_index))"
              :key="'checkbox_' + String(form_index)"
              :id="'checkbox_' + String(form_index)"
            >
              更新対象とする
            </el-checkbox>
          </div>
        </div>
      </div>
        <!-- v-bind:class="{ 'non-enterable': !(getModelItem(tableComponent.model)) }" -->
      <Table
        :key="'table_' + String(form_index)"
        :id="'table_' + String(form_index)"
        :table-data="getModelItem(tableComponent.tableDataName)"
        :tableDataName="tableComponent.tableDataName"
        :addRowMode="tableComponent.addRowMode && getModelItem(tableComponent.model)"
        @add-row="addRow"
      >
        <template #columns class="TableColumnComponets">
          <template v-for="(tableColumn, index) in tableColumns(tableComponent.category)">
            <MenuColumn v-if="tableColumn.component == 'MenuColumn'"
              :key="index"
              @copy="copyRow"
              :cbdelete="deleteRow"
            />
            <MinusColumn v-if="tableColumn.component == 'MinusColumn' && getModelItem(tableComponent.model)"
              :key="index"
              :addRowMode="tableComponent.addRowMode"
              :deletable="changeable"
              :deleteCase="tableComponent.deleteCase"
              :tableDataCount="getRecordCount(tableComponent.tableDataName)"
              :tableDataName="tableComponent.tableDataName"
              @delete-row="deleteRow"
            />
              <!-- :value="weight[$index][tableColumn.prop]"
              @input="value => updateValue(value, $index, tableColumn.prop)" -->
              <!-- v-model="weightInputItemList[tableColumn.prop]" -->
            <component v-else-if="tableColumn.component == 'TextColumn'"
              :is="tableColumn.component"
              :key="index"
              v-model="inputItemList(tableComponent.category)[tableColumn.prop]"
              :prop="tableColumn.prop"
              :label="tableColumn.label"
              :editable="tableColumn.editable"
              :width="tableColumn.width"
              :maxlength="tableColumn.maxlength"
              :required="tableColumn.required"
              :placeholder="tableColumn.placeholder"
              :disabled="getDisabled(tableColumn.disabled, getModelItem(tableComponent.model))"
              :uppercase="tableColumn.uppercase"
              :addRowMode="tableComponent.addRowMode"
              :changeable="changeable"
              :changeCase="tableColumn.changeCase"
              :tableDataCount="getRecordCount(tableComponent.tableDataName)"
              :tableDataName="tableComponent.tableDataName"
            />
            <component v-else-if="tableColumn.component == 'NumericColumn'"
              :is="tableColumn.component"
              :key="index"
              v-model="inputItemList(tableComponent.category)[tableColumn.prop]"
              :prop="tableColumn.prop"
              :label="tableColumn.label"
              :editable="tableColumn.editable"
              :width="tableColumn.width"
              :maxlength="tableColumn.maxlength"
              :required="tableColumn.required"
              :placeholder="tableColumn.placeholder"
              :disabled="getDisabled(tableColumn.disabled, getModelItem(tableComponent.model))"
              :min="tableColumn.min"
              :max="tableColumn.max"
              :precision="tableColumn.precision"
              :step="tableColumn.step"
              :controls="tableColumn.controls"
              :addRowMode="tableComponent.addRowMode"
              :changeable="changeable"
              :changeCase="tableColumn.changeCase"
              :tableDataCount="getRecordCount(tableComponent.tableDataName)"
              :tableDataName="tableComponent.tableDataName"
            />
            <component v-else-if="tableColumn.component == 'CodeColumn'"
              :is="tableColumn.component"
              :key="index"
              v-model="inputItemList(tableComponent.category)[tableColumn.prop]"
              :prop="tableColumn.prop"
              :label="tableColumn.label"
              :editable="tableColumn.editable"
              :width="tableColumn.width"
              :required="tableColumn.required"
              :placeholder="tableColumn.placeholder"
              :disabled="getDisabled(tableColumn.disabled, getModelItem(tableComponent.model))"
              :initialize="tableColumn.initialize"
              :addRowMode="tableComponent.addRowMode"
              :changeable="changeable"
              :changeCase="tableColumn.changeCase"
              :tableDataCount="getRecordCount(tableComponent.tableDataName)"
              :tableDataName="tableComponent.tableDataName"
              :codeId="tableColumn.codeId"
            />
            <component v-else-if="tableColumn.component == 'SelectColumn'"
              :is="tableColumn.component"
              :key="index"
              v-model="inputItemList(tableComponent.category)[tableColumn.prop]"
              :prop="tableColumn.prop"
              :label="tableColumn.label"
              :editable="tableColumn.editable"
              :width="tableColumn.width"
              :required="tableColumn.required"
              :placeholder="tableColumn.placeholder"
              :disabled="getDisabled(tableColumn.disabled, getModelItem(tableComponent.model))"
              :initialize="tableColumn.initialize"
              :addRowMode="tableComponent.addRowMode"
              :changeable="changeable"
              :changeCase="tableColumn.changeCase"
              :tableDataCount="getRecordCount(tableComponent.tableDataName)"
              :tableDataName="tableComponent.tableDataName"
              :optionsList="getCodeList(tableColumn.optionListCode)"
              :filterable="tableColumn.filterable"
            />
            <component v-else-if="tableColumn.component == 'CheckBoxColumn'"
              :is="tableColumn.component"
              :key="index"
              v-model="inputItemList(tableComponent.category)[tableColumn.prop]"
              :prop="tableColumn.prop"
              :label="tableColumn.label"
              :width="tableColumn.width"
              :disabled="getDisabled(tableColumn.disabled, getModelItem(tableComponent.model))"
              :tableDataName="tableComponent.tableDataName"
            />
            <component v-else-if="tableColumn.component == 'ExemptionRateColumn'"
              :is="tableColumn.component"
              :key="index"
              v-model="inputItemList(tableComponent.category)[tableColumn.prop]"
              :prop="tableColumn.prop"
              :label="tableColumn.label"
              :editable="tableColumn.editable"
              :width="tableColumn.width"
              :maxlength="tableColumn.maxlength"
              :required="tableColumn.required"
              :placeholder="tableColumn.placeholder"
              :disabled="getDisabled(tableColumn.disabled, getModelItem(tableComponent.model))"
              :uppercase="tableColumn.uppercase"
              :addRowMode="tableComponent.addRowMode"
              :changeable="changeable"
              :changeCase="tableColumn.changeCase"
              :tableDataCount="getRecordCount(tableComponent.tableDataName)"
              :tableDataName="tableComponent.tableDataName"
            />
          </template>
        </template>
      </Table>
    </template>
    <template v-if='formMode === "edit" '>
      <el-divider />
      <div class="el-form--inline">
        <DateTime v-model="updatedOn" label="更新日時" prop="updated_on"
            :required="!searchMode" :searchCond="searchMode" :disabled="editMode"
            format="yyyy/MM/dd HH:mm:ss" />
        <Blank />
      </div>
    </template>
    <el-divider />
  </el-form>
</template>

<script>
// import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import ChargeYear from '@/components/molecules/form/select/ChargeYear.vue'
import DateTime from '@/components/molecules/form/date/DateTime.vue'
// import RouteCode from '@/components/molecules/form/select/RouteCode.vue'
import Select from '@/components/molecules/form/select/Select.vue'
import Numeric from '@/components/molecules/form/number/Numeric.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'
import AirportCode from '@/components/molecules/form/select/AirportCode.vue'
import ExemptionRate from '@/components/molecules/form/text/ExemptionRate.vue'
// import Table from '../../../molecules/table/Table.vue'

export default {
  components: {
    // BillingYm,
    ChargeYear,
    DateTime,
    // RouteCode,
    Select,
    Numeric,
    Blank,
    AirportCode,
    ExemptionRate,
    Table: () => import('@/components/molecules/table/TableEdit.vue'),
    TextColumn: () => import('@/components/molecules/table/column/TextColumn.vue'),
    CodeColumn: () => import('@/components/molecules/table/column/CodeColumn.vue'),
    NumericColumn: () => import('@/components/molecules/table/column/NumericColumn.vue'),
    ExemptionRateColumn: () => import('@/components/molecules/table/column/ExemptionRateColumn.vue'),
    SelectColumn: () => import('@/components/molecules/table/column/SelectColumn.vue'),
    CheckBoxColumn: () => import('@/components/molecules/table/column/CheckBoxColumn.vue'),
    MenuColumn: () => import('@/components/molecules/table/column/MenuColumn.vue'),
    MinusColumn: () => import('@/components/molecules/table/column/MinusColumn.vue')
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    billingYmMode: {
      type: String,
      default: 'search'
    },
    editDisabledMode: {
      type: Boolean,
      default: false
    },
    tableType: String,
    routeAirportCodeList: {
      type: Array,
      default: () => ([])
    },
    originalFormModel: Object
  },
  data () {
    return {
      // routeAirportCodeList: {},
      tableComponents: [
        { category: 'weight', label: '重量料金', model: 'weight_update_flag', height: '100', tableDataName: 'weights', addRowMode: false, deleteCase: null },
        { category: 'noise', label: '騒音料金', model: 'noise_update_flag', height: '100', tableDataName: 'noises', addRowMode: false, deleteCase: null },
        { category: 'remoteIsland', label: '離島減免', model: 'remote_island_update_flag', height: '100', tableDataName: 'remoteIslands', addRowMode: false, deleteCase: null },
        { category: 'routeDiscount', label: '路線割引', model: 'route_discount_update_flag', height: '100', tableDataName: 'routeDiscounts', addRowMode: true, deleteCase: null },
        { category: 'weightDiscount', label: '重量割引', model: 'weight_discount_update_flag', height: '100', tableDataName: 'weightDiscounts', addRowMode: true, deleteCase: 'ONLY_LAST' },
        { category: 'type', label: '飛行属性割引', model: 'type_update_flag', height: '100', tableDataName: 'types', addRowMode: false, deleteCase: null }
      ],
      weightTableColumns: [
        { component: 'NumericColumn', prop: 'data_range_from', label: 'from', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '', disabled: true, min: 0, max: 999999, precision: 0, step: 1 },
        { component: 'NumericColumn', prop: 'data_range_to', label: 'to', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '', disabled: true, min: 0, max: 999999, precision: 0, step: 1 },
        { component: 'NumericColumn', prop: 'charge', label: '単価', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '単価', disabled: false, min: 0, max: 999999, precision: 0, step: 1 },
        // { component: 'CheckBoxColumn', prop: 'flat_charge_flag', label: '定額フラグ', width: '100' },
        { component: 'CodeColumn', prop: 'flat_charge_flag', label: '定額フラグ', width: '100', initialize: true, required: true, disabled: true, editable: true, codeId: 'FLAT_CHARGE_FLAG' }
        // { component: 'MenuColumn' }
      ],
      weightInputItemList: {},
      noiseTableColumns: [
        { component: 'NumericColumn', prop: 'data_range_from', label: 'from', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '', disabled: true, min: 0, max: 999999, precision: 0, step: 1 },
        { component: 'NumericColumn', prop: 'data_range_to', label: 'to', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '', disabled: true, min: 0, max: 999999, precision: 0, step: 1 },
        { component: 'NumericColumn', prop: 'charge', label: '単価', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '単価', disabled: false, min: 0, max: 999999, precision: 0, step: 1 },
        // { component: 'CheckBoxColumn', prop: 'flat_charge_flag', label: '定額フラグ', width: '100' },
        { component: 'CodeColumn', prop: 'flat_charge_flag', label: '定額フラグ', width: '100', initialize: true, required: true, disabled: true, editable: true, codeId: 'FLAT_CHARGE_FLAG' }
        // { component: 'MenuColumn' }
      ],
      noiseInputItemList: {},
      remoteIslandTableColumns: [
        // { component: 'TextColumn', prop: 'route_airport_code', label: '適用路線空港', width: '100', initialize: '', required: true, editable: true, maxlength: 4 },
        { component: 'CodeColumn', prop: 'route_airport_code', label: '適用路線空港', width: '100', initialize: true, required: true, disabled: true, editable: true, codeId: 'REMOTE_ISLAND_CODE' },
        // { component: 'TextColumn', prop: 'exemption_rate_by_remote_island', label: '減免率', width: '100', initialize: '', required: true, editable: true, maxlength: 6 },
        { component: 'ExemptionRateColumn', prop: 'exemption_rate_by_remote_island', label: '減免率', width: '100', initialize: '', required: true, editable: true, maxlength: 5 }
        // { component: 'MenuColumn' }
      ],
      remoteIslandInputItemList: {},
      routeDiscountTableColumns: [
        // { component: 'TextColumn', prop: 'route_airport_code', label: '適用路線空港', width: '100', initialize: '', required: true, editable: true, maxlength: 4 },
        // { component: 'SelectColumn', prop: 'route_airport_code', label: '適用路線空港', width: '100', initialize: true, required: true, editable: true, maxlength: 4, optionsList: this.routeAirportCodeList },
        { component: 'SelectColumn', prop: 'route_airport_code', label: '適用路線空港', width: '100', initialize: true, required: true, editable: true, filterable: true, maxlength: 4, optionListCode: 'ROUTE_DISCOUNT' },
        // { component: 'TextColumn', prop: 'exemption_rate_by_route', label: '減免率', width: '100', initialize: '', required: true, editable: true, maxlength: 6 },
        { component: 'ExemptionRateColumn', prop: 'exemption_rate_by_route', label: '減免率', width: '100', initialize: '', required: true, editable: true, maxlength: 5 },
        // { component: 'TextColumn', prop: 'error_check_flag', label: '', width: '100', initialize: '', required: true, display: false, maxlength: 4 },
        { component: 'MinusColumn' }
      ],
      routeDiscountInputItemList: {},
      weightDiscountTableColumns: [
        // { component: 'NumericColumn', prop: 'min_weight', label: 'from', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '', disabled: false, min: 0, max: 999999, precision: 0, step: 1 },
        // { component: 'NumericColumn', prop: 'min_weight', label: 'from', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '', disabled: true, min: 0, max: 999999, precision: 0, step: 1 },
        // { component: 'NumericColumn', prop: 'max_weight', label: 'to', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '', disabled: false, min: 0, max: 999999, precision: 0, step: 1 },
        { component: 'NumericColumn', prop: 'min_weight', label: 'from', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '', disabled: true, min: 0, max: 999999, precision: 0, step: 1, changeCase: 'NONE' },
        { component: 'NumericColumn', prop: 'max_weight', label: 'to', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '', disabled: false, min: 0, max: 999999, precision: 0, step: 1, changeCase: 'ONLY_LAST' },
        // { component: 'TextColumn', prop: 'exemption_rate_by_weight', label: '減免率', width: '100', initialize: '', required: true, editable: true, maxlength: 6 },
        { component: 'ExemptionRateColumn', prop: 'exemption_rate_by_weight', label: '減免率', width: '100', initialize: '', required: true, editable: true, maxlength: 5 },
        { component: 'MinusColumn' }
      ],
      weightDiscountInputItemList: {},
      typeTableColumns: [
        { component: 'CodeColumn', prop: 'type_value', label: '区分値', width: '100', initialize: true, required: true, disabled: true, editable: true, codeId: 'TYPE_VALUE' },
        // { component: 'TextColumn', prop: 'exemption_rate_by_type', label: '減免率', width: '100', initialize: '', required: true, editable: true, maxlength: 6 },
        { component: 'ExemptionRateColumn', prop: 'exemption_rate_by_type', label: '減免率', width: '100', initialize: '', required: true, editable: true, maxlength: 5 }
        // { component: 'MenuColumn' }
      ],
      typeInputItemList: {},
      oldRouteDiscountsList: []
    }
  },
  computed: {
    chargeYear: {
      get () {
        return this.model.charge_year
      },
      set (chargeYear) {
        const form = { ...this.model }
        form.charge_year = chargeYear
        this.$emit('input', form)
      }
    },
    // billingYm: {
    //   get () {
    //     return this.model.billing_ym
    //   },
    //   set (billingYm) {
    //     const form = { ...this.model }
    //     form.billing_ym = billingYm
    //     this.$emit('input', form)
    //   }
    // },
    routeCode: {
      get () {
        return this.model.route_code
      },
      set (routeCode) {
        const form = { ...this.model }
        form.route_code = routeCode
        this.$emit('input', form)
      }
    },
    jetType: {
      get () {
        return this.model.jet_type
      },
      set (jetType) {
        const form = { ...this.model }
        form.jet_type = jetType
        this.$emit('input', form)
      }
    },
    paidType: {
      get () {
        return this.model.paid_type
      },
      set (paidType) {
        const form = { ...this.model }
        form.paid_type = paidType
        this.$emit('input', form)
      }
    },
    minWeight: {
      get () {
        return this.model.min_weight
      },
      set (minWeight) {
        // alert('set')
        const form = { ...this.model }
        form.min_weight = minWeight
        this.$emit('input', form)
      }
    },
    maxWeight: {
      get () {
        return this.model.max_weight
      },
      set (maxWeight) {
        const form = { ...this.model }
        form.max_weight = maxWeight
        this.$emit('input', form)
      }
    },
    updatedOn: {
      get () {
        return this.model.updated_on
      },
      set (updatedOn) {
        const form = { ...this.model }
        form.updated_on = updatedOn
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
  },
  mounted () {
    this.weightInputItemList = {}
    for (var i = 0; i < this.weightTableColumns.length; i += 1) {
      this.$set(this.weightInputItemList, this.weightTableColumns[i].prop, '')
    }
    this.noiseInputItemList = {}
    for (i = 0; i < this.noiseTableColumns.length; i += 1) {
      this.$set(this.noiseInputItemList, this.noiseTableColumns[i].prop, '')
    }
    this.remoteIslandInputItemList = {}
    for (i = 0; i < this.remoteIslandTableColumns.length; i += 1) {
      this.$set(this.remoteIslandInputItemList, this.remoteIslandTableColumns[i].prop, '')
    }
    this.routeDiscountInputItemList = {}
    for (i = 0; i < this.routeDiscountTableColumns.length; i += 1) {
      this.$set(this.routeDiscountInputItemList, this.routeDiscountTableColumns[i].prop, '')
    }
    this.typeInputItemList = {}
    for (i = 0; i < this.typeTableColumns.length; i += 1) {
      this.$set(this.typeInputItemList, this.typeTableColumns[i].prop, '')
    }
    // this.routeAirportCodeList = {}
    // this.$axios
    //   .get('/route-airport-code')
    //   .then((res) => {
    //     this.routeAirportCodeList = res.data.list
    //     console.log(this.routeAirportCodeList)
    //     // for (var i = 0; i <= this.routeAirportCodeList.length - 1; i += 1) {
    //     //   // this.tableData[i].selected = false
    //     //   this.$set(this.routeAirportCodeList[i], 'selected', false)
    //     // }
    //   })
    //   .catch((e) => {
    //     console.log(e)
    //   })
    //   .finally(() => {
    //     this.$loadingMask.off()
    //   })
  },
  watch: {
    'model.routeDiscounts': {
      handler: function (newValue, oldValue) {
        oldValue = this.oldRouteDiscountsList
        this.oldRouteDiscountsList = JSON.parse(JSON.stringify(newValue))
        if (oldValue.length < newValue.length) {
          // alert('行追加')
        } else if (oldValue.length > newValue.length) {
          // alert('行削除')
        } else {
          for (let i = 0; i < newValue.length; i++) {
            const oldJson = JSON.stringify(oldValue[i])
            const newJson = JSON.stringify(newValue[i])
            var element = document.getElementById('table_' + 3)
            var trElement = element.getElementsByTagName('tr')
            var tdElement = trElement[i + 1].getElementsByTagName('td')
            // trElement[i + 1].classList.add('error-background')
            for (let k = 0; k < tdElement.length; k++) {
              tdElement[k].classList.remove('error-background')
            }
            if (oldJson !== newJson) {
              for (let j = 0; j < oldValue.length; j++) {
                if (newValue[i].route_airport_code === oldValue[j].route_airport_code) {
                  if (i !== j) {
                    // alert((i + 1) + '行目の適用路線空港は' + (j + 1) + '行目と重複しています')
                    this.$message.error({
                      message: (i + 1) + '行目の適用路線空港は' + (j + 1) + '行目と重複しています',
                      showClose: true
                    })
                    // エラーチェックフラグ（１：重複）を立てる
                    this.model.routeDiscounts[i].error_check_flag = 1
                    // trElement[i + 1].classList.add('error-background')
                    for (let k = 0; k < tdElement.length; k++) {
                      tdElement[k].classList.add('error-background')
                    }
                  }
                  console.log(trElement)
                  console.log(element)
                  // element.classList.add('tr:nth-child(' + i + '){background:red;}')
                  // element.classList.add('error-background')
                  break
                } else {
                  this.model.routeDiscounts[i].error_check_flag = 0
                }
              }
              // feesForWeightAndNoiseMasterFormModel.routeDiscounts[i].route_airport_code
              // alert((i + 1) + '行目が変更されました')
            }
          }
        }
      },
      deep: true
    },
    'model.weightDiscounts': {
      handler: function (newValue, oldValue) {
        for (let i = 0; i < newValue.length; i++) {
          var element = document.getElementById('table_' + 4)
          var trElement = element.getElementsByTagName('tr')
          var tdElement = trElement[i + 1].getElementsByTagName('td')
          for (let j = 0; j < tdElement.length; j++) {
            tdElement[j].classList.remove('error-background')
          }
          // const newJson = JSON.stringify(newValue[i])
          if (newValue[i].min_weight >= newValue[i].max_weight) {
            // alert((i + 1) + '行目の適用路線空港は' + (j + 1) + '行目と重複しています')
            this.$message.error({
              message: (i + 1) + '行目が　min_weight >= max_weight エラーです。',
              showClose: true
            })
            // エラーチェックフラグ（１：重複）を立てる
            this.model.weightDiscounts[i].error_check_flag = 1
            for (let j = 0; j < tdElement.length; j++) {
              tdElement[j].classList.add('error-background')
            }
          } else {
            this.model.routeDiscounts[i].error_check_flag = 0
          }
        }
      },
      deep: true
    }
  },
  methods: {
    getModelItem (key) {
      return this.model[key]
    },
    getRecordCount (key) {
      return this.model[key].length
    },
    changeable (addRowMode, deleteCase, rowCount, index) {
      // 変更可能条件
      var result = addRowMode
      if (result) {
        switch (deleteCase) {
          case 'ONLY_LAST':
            if (rowCount !== index + 1) {
              result = false
            }
            break
          default:
            result = true
            break
        }
      }
      return result
    },
    getDisabled (disabled, updateFlag) {
      var result = disabled
      if (!result) {
        result = !updateFlag
      }
      return result
    },
    onChangeCheckBox (value, key, index) {
      const form = { ...this.model }
      form[key] = value
      this.$emit('input', form)
      // 更新対象チェックを外した際にデータを元に戻す
      if (!value) {
        this.model[this.tableComponents[index].tableDataName].splice(0)
        var list = JSON.parse(JSON.stringify(this.originalFormModel[this.tableComponents[index].tableDataName]))
        for (var i = 0; i < Object.keys(list).length; i += 1) {
          this.model[this.tableComponents[index].tableDataName].push(list[i])
        }
        // // 親要素取得
        // var tableElement = document.getElementById('table_' + String(index))
        // // 子要素取得
        // var errorElement = tableElement.getElementsByClassName('el-form-item__error')
        // for (i = 0; i < errorElement.length; i += 1) {
        //   errorElement[i].style.display = 'none'
        // }
        this.$refs.feesForWeightAndNoiseMasterForm.validate()
      }
    },
    tableColumns (category) {
      switch (category) {
        case 'weight':
          return this.weightTableColumns
        case 'noise':
          return this.noiseTableColumns
        case 'remoteIsland':
          return this.remoteIslandTableColumns
        case 'routeDiscount':
          return this.routeDiscountTableColumns
        case 'weightDiscount':
          return this.weightDiscountTableColumns
        case 'type':
          return this.typeTableColumns
      }
    },
    inputItemList (category) {
      switch (category) {
        case 'weight':
          return this.weightInputItemList
        case 'noise':
          return this.noiseInputItemList
        case 'remoteIsland':
          return this.remoteIslandInputItemList
        case 'routeDiscount':
          return this.routeDiscountInputItemList
        case 'weightDiscount':
          return this.weightDiscountInputItemList
        case 'type':
          return this.typeInputItemList
      }
    },
    getCodeList (codeType) {
      switch (codeType) {
        case 'ROUTE_DISCOUNT':
          return this.routeAirportCodeList
      }
    },
    clearFields () {
      this.$refs.feesForWeightAndNoiseMasterForm.resetFields()
      this.billingYm = this.getDefaultBillingYm()
      // if (this.searchMode) {
      //   this.model.start_date_time = null
      //   this.model.end_date_time = null
      //   this.model.manual_data_only = false
      //   this.model.automatic_data_only = false
      // }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.feesForWeightAndNoiseMasterForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    },
    addWeights () {
      this.model.weights.push({ data_range_from: undefined, data_range_to: undefined, charge: undefined })
    },
    delWeights (index) {
      this.model.weights.splice(index, 1)
    },
    addNoises () {
      this.noises.push({ dataRangeFrom: undefined, dataRangeTo: undefined, charge: undefined })
    },
    delNoises (index) {
      this.noises.splice(index, 1)
    },
    addRouteAndWeights () {
      this.routeDiscounts.push({ routeAirportCode: undefined, exemptionRateByRouteAndWeight: undefined })
    },
    delRouteAndWeights (index) {
      this.routeDiscounts.splice(index, 1)
    },
    addTypes () {
      this.types.push({ routeAirportCode: undefined, exemptionRateByType: undefined })
    },
    delTypes (index) {
      this.types.splice(index, 1)
    },
    addRow (tableDataName, tableData) {
      var tabaleArray = {}
      switch (tableDataName) {
        case 'weights':
          tabaleArray = this.weightTableColumns
          break
        case 'noises':
          tabaleArray = this.noiseTableColumns
          break
        case 'remoteIslands':
          tabaleArray = this.remoteIslandTableColumns
          break
        case 'routeDiscounts':
          tabaleArray = this.routeDiscountTableColumns
          break
        case 'weightDiscounts':
          tabaleArray = this.weightDiscountTableColumns
          // 最終行のmax_weightがnullの場合、終了
          if (tableData.length > 0) {
            if (tableData[tableData.length - 1].max_weight === null || tableData[tableData.length - 1].max_weight === undefined) {
              return
            }
          }
          break
        case 'types':
          tabaleArray = this.typeTableColumns
          break
      }
      var row = {}
      for (var i = 0; i <= tabaleArray.length - 1; i += 1) {
        row[tabaleArray[i].prop] = undefined
      }
      this.model[tableDataName] = tableData
      if (tableDataName === 'weightDiscounts') {
        if (tableData.length === 0) {
          // 最初の行のmin_weightは必ず0
          row.min_weight = 0
        } else {
          // ひとつ前の行のmax_weightに1を足す
          row.min_weight = tableData[tableData.length - 1].max_weight + 1
        }
      }
      this.model[tableDataName].push(row)
    },
    deleteRow (tableDataName, index) {
      // var tabaleArray = {}
      // switch (tableDataName) {
      //   case 'weights':
      //     tabaleArray = this.weightTableColumns
      //     break
      //   case 'noises':
      //     tabaleArray = this.noiseTableColumns
      //     break
      //   case 'remoteIslands':
      //     tabaleArray = this.remoteIslandTableColumns
      //     break
      //   case 'routeDiscounts':
      //     tabaleArray = this.routeDiscountTableColumns
      //     break
      //   case 'weightDiscounts':
      //     tabaleArray = this.weightDiscountTableColumns
      //     break
      //   case 'types':
      //     tabaleArray = this.typeTableColumns
      //     break
      // }
      // var row = {}
      // for (var i = 0; i <= tabaleArray.length - 1; i += 1) {
      //   row[tabaleArray[i].prop] = undefined
      // }
      // this.model[tableDataName] = tableData
      this.model[tableDataName].splice(index, 1)
    }
  }
}
</script>

<style lang="scss">
.fees-for-weight-and-noise-master-form {
  .el-form--inline {
    display: flex;
    // justify-content: space-between;
    // margin-left: 10px;
  }
  td .el-form-item {
    margin-bottom: 5px !important;
  }
  td .el-form-item__content{
    margin-left: 0% !important;
  }
  td .el-form-item.numeric .el-input-number{
    width: 13em !important;
  }
  // .error-background {
  //   background-color: red !important;
  // }
  .error-background {
    background-color: rgb(253, 226, 226) !important;
  }
  // .table_3 .el-table__row:nth-of-type(3) {
  //   background: red;
  // }
}
</style>
